import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api"

const KEY = ["me-bookmark-ids"] as const

export function useBookmarkIds() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<string[]>("/bookmarks/ids"),
    staleTime: 30_000,
  })
}

export function useToggleBookmark() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({
      paperId,
      bookmarked,
    }: { paperId: string; bookmarked: boolean }) => {
      if (bookmarked) {
        await api.delete<void>(`/bookmarks/by-paper/${paperId}`)
      } else {
        await api.post(`/bookmarks`, { paper_id: paperId })
      }
    },
    onMutate: async ({ paperId, bookmarked }) => {
      await qc.cancelQueries({ queryKey: KEY })
      const prev = qc.getQueryData<string[]>(KEY) ?? []
      const next = bookmarked
        ? prev.filter((id) => id !== paperId)
        : [...prev, paperId]
      qc.setQueryData<string[]>(KEY, next)
      return { prev }
    },
    onError: (_e, _vars, ctx) => {
      if (ctx?.prev) qc.setQueryData(KEY, ctx.prev)
    },
    onSettled: () => {
      qc.invalidateQueries({ queryKey: KEY })
      qc.invalidateQueries({ queryKey: ["me-bookmarks"] })
    },
  })
}
